import React from "react";

import { SortingOption } from "../types";

import { PopupContainerBase, SortingOptionButton } from "../AvailablePositions.styles";

interface SortingOptionsProps {
  onOptionSelect: (option: SortingOption) => void
}

const SortingOptions = ({onOptionSelect}: SortingOptionsProps) => {
  return (
    <PopupContainerBase>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.datePosted)} className='no-fastclick'>
        {SortingOption.datePosted}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.startDate)} className='no-fastclick'>
        {SortingOption.startDate}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.distance)} className='no-fastclick'>
        {SortingOption.distance}
      </SortingOptionButton>
      <SortingOptionButton onClick={() => onOptionSelect(SortingOption.applied)} className='no-fastclick'>
        {SortingOption.applied}
      </SortingOptionButton>
    </PopupContainerBase>
  );
}

export default SortingOptions;
